<template>
  <Icon>
    <svg
      slot="svg"
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Rejestracja"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        transform="translate(-1000.000000, -516.000000)"
      >
        <g
          id="Group-4"
          transform="translate(490.000000, 194.000000)"
          fill="#ffffff"
        >
          <g
            id="Group-3"
            transform="translate(510.000000, 322.000000)"
          >
            <g id="icons/cooling">
              <path
                id="Fill-1"
                d="M42,41 C42,41.552 41.551,42 41,42 L3,42 C2.449,42 2,41.552 2,41 L2,3 C2,2.448 2.449,2 3,2 L41,2 C41.551,2 42,2.448 42,3 L42,41 Z M41,0 L3,0 C1.346,0 0,1.346 0,3 L0,41 C0,42.654 1.346,44 3,44 L41,44 C42.654,44 44,42.654 44,41 L44,3 C44,1.346 42.654,0 41,0 Z"
              />
              <path
                id="Fill-3"
                d="M5,6 C5.552,6 6,5.552 6,5 C6,4.448 5.552,4 5,4 C4.448,4 4,4.448 4,5 C4,5.552 4.448,6 5,6"
              />
              <path
                id="Fill-5"
                d="M39,4 C38.448,4 38,4.448 38,5 C38,5.552 38.448,6 39,6 C39.552,6 40,5.552 40,5 C40,4.448 39.552,4 39,4"
              />
              <path
                id="Fill-7"
                d="M5,38 C4.448,38 4,38.448 4,39 C4,39.552 4.448,40 5,40 C5.552,40 6,39.552 6,39 C6,38.448 5.552,38 5,38"
              />
              <path
                id="Fill-9"
                d="M39,38 C38.448,38 38,38.448 38,39 C38,39.552 38.448,40 39,40 C39.552,40 40,39.552 40,39 C40,38.448 39.552,38 39,38"
              />
              <path
                id="Fill-11"
                d="M36.1113,29.522 C32.1413,29.607 27.7323,27.068 25.7863,23.605 C29.3863,25.381 34.2323,25.437 37.9033,23.762 C37.6763,25.826 37.0493,27.769 36.1113,29.522 M30.4633,35.571 C26.9883,33.656 24.4313,29.257 24.4763,25.284 C26.7043,28.617 30.8633,31.08 34.8743,31.47 C33.6743,33.097 32.1823,34.495 30.4633,35.571 M8.4233,30.475 C10.3343,26.995 14.7393,24.436 18.7163,24.477 C15.3783,26.709 12.9063,30.877 12.5233,34.896 C10.8983,33.704 9.5023,32.21 8.4233,30.475 M6.0963,20.238 C6.3233,18.174 6.9503,16.231 7.8893,14.478 C11.8563,14.39 16.2673,16.932 18.2143,20.395 C14.6123,18.619 9.7673,18.563 6.0963,20.238 M13.5363,8.429 C17.0123,10.345 19.5703,14.747 19.5243,18.72 C17.2963,15.389 13.1363,12.927 9.1263,12.529 C10.3263,10.902 11.8183,9.504 13.5363,8.429 M35.5773,13.525 C33.6653,17.006 29.2613,19.571 25.2813,19.523 C28.6213,17.292 31.0933,13.123 31.4773,9.104 C33.1013,10.296 34.4973,11.79 35.5773,13.525 M22.0003,24 C20.8973,24 20.0003,23.103 20.0003,22 C20.0003,20.897 20.8973,20 22.0003,20 C23.1033,20 24.0003,20.897 24.0003,22 C24.0003,23.103 23.1033,24 22.0003,24 M23.6033,18.215 C25.3773,14.618 25.4373,9.778 23.7663,6.108 C25.8183,6.332 27.7633,6.939 29.5203,7.871 C29.6063,11.842 27.0713,16.266 23.6033,18.215 M21.4623,6.025 C23.5083,9.422 23.5203,14.506 21.4963,17.92 C21.2343,13.92 18.8693,9.702 15.5903,7.358 C17.3993,6.563 19.3793,6.095 21.4623,6.025 M20.3973,25.785 C18.6223,29.382 18.5633,34.222 20.2333,37.892 C18.1813,37.668 16.2363,37.062 14.4793,36.129 C14.3933,32.158 16.9283,27.734 20.3973,25.785 M22.5383,37.975 C20.4913,34.578 20.4803,29.494 22.5043,26.08 C22.7663,30.08 25.1313,34.298 28.4093,36.642 C26.6003,37.438 24.6213,37.905 22.5383,37.975 M39.4653,21.114 C39.1353,20.943 38.7373,20.966 38.4323,21.177 C35.0513,23.509 29.6543,23.613 26.0843,21.499 C30.0923,21.234 34.3153,18.855 36.6553,15.565 C37.0273,16.416 37.3313,17.306 37.5543,18.234 C37.6843,18.772 38.2273,19.104 38.7613,18.972 C39.2983,18.843 39.6283,18.303 39.4993,17.766 C37.5443,9.66 30.3483,4 22.0003,4 C12.0743,4 4.0003,12.075 4.0003,22 C4.0003,22.372 4.2063,22.713 4.5353,22.886 C4.8633,23.058 5.2623,23.034 5.5683,22.823 C8.9513,20.488 14.3543,20.387 17.9243,22.507 C13.9173,22.774 9.6863,25.144 7.3433,28.433 C6.9723,27.583 6.6693,26.693 6.4453,25.766 C6.3163,25.229 5.7733,24.897 5.2383,25.028 C4.7013,25.157 4.3713,25.697 4.5013,26.234 C6.4553,34.34 13.6513,40 22.0003,40 C31.9253,40 40.0003,31.925 40.0003,22 C40.0003,21.628 39.7943,21.287 39.4653,21.114"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsCoolingIcon",
  components: {
    Icon
  },
  extends: Icon
};
</script>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-cooling.icon.vue